import type { WhatsappIntegration } from '@chukua/common';

/** The line under a provider's name: the number it sends from and when the provider last accepted its details. */
export function whatsappIntegrationFacts(integration: WhatsappIntegration): string[] {
  const sender = integration.config['sender'];
  const facts = typeof sender === 'string' && sender !== '' ? [`From +${sender.replace(/^\+/, '')}`] : [];
  facts.push(
    integration.lastCheckedAt
      ? `Checked ${new Date(integration.lastCheckedAt).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}`
      : 'Never checked',
  );
  return facts;
}
